/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ReportingRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      ledgers: this.store.findAll('finance/ledger'),
      ledgerItems: this.store.findAll('finance/ledger-item'),
    });
  }
}
